module.exports = __webpack_public_path__ + "img/dc6ba26.png";